import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader } from '@/http-common';

const state = () => ({
    spk: [], // Список СПК
    spkOrganisation: [], // Список СПК организаций
});

const getters = {};

const mutations = {
    SET_SPK(state, spk) {
        state.spk = spk
    },
    SET_SPK_ORGANISATION(state, spkOrganisation) {
        state.spkOrganisation = spkOrganisation
    },
    ADD_SPK(state, spk) {
        state.spk.push(spk)
    },
    UPDATE_SPK(state, updatedSpk) {
        state.spk = state.spk.map(item => item.id === updatedSpk.id ? updatedSpk : item)
    },
    DELETE_SPK(state, spkId) {
        state.spk = state.spk.filter(el => el.id !== spkId)
    },
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    // Получить список СПК
    async LOAD_SPK({ commit, rootState }) {
        await httpWithLoader.get(`/spk`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_SPK', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async LOAD_SPK_ORGANISATION({ commit, rootState }) {
        await httpWithLoader.get(`/spk-organisations`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_SPK_ORGANISATION', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать СПК
    async CREATE_SPK({ commit, rootState }, params) {
        await httpWithLoader.post(`/spk`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            const tempSpk = response.data.is_spk ? 1 : 0
            commit('ADD_SPK', Object.assign(response.data, { is_spk: tempSpk }))
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Изменить конкретного пользователя
    async UPDATE_SPK({ commit, rootState }, { spkId, params }) {
        return await httpWithLoader.put(`/spk/${ spkId }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                const tempSpk = response.data.is_spk ? 1 : 0;
                commit('UPDATE_SPK', Object.assign(response.data, { is_spk: tempSpk }))

                return response.status
            })
            .catch((reject) => {
                handleError(reject, commit)

                return reject.response.status
            });
    },

    // Создать пользователя
    async DELETE_SPK({ commit, rootState }, spkId) {
        await httpWithLoader.delete(`/spk/${spkId}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('DELETE_SPK', spkId)
            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
